import React from "react";

export const GradientDefs = ({ gradient }: { gradient?: string }) => {
  if (!gradient) return null;

  const match = gradient.match(/linear-gradient\((.*)\)$/);
  if (!match) return null;

  const parts =
    match[1].match(/(#[0-9a-fA-F]{3,6}|rgba?\([^)]*\)|[0-9.]+deg)/g) ?? [];
  const anglePart = parts.find((p) => /\d+deg/.test(p)) ?? "0deg";
  const angle = Number(anglePart.replace("deg", "")) || 0;

  const colors = parts.filter((p) => /^#|rgb/.test(p));

  if (colors.length < 2) return null;

  return (
    <defs>
      <linearGradient
        id="icon-gradient"
        data-testid="icon-gradient"
        gradientTransform={`rotate(${angle})`}
      >
        {colors.map((color, i) => (
          <stop
            key={i}
            offset={`${(i / (colors.length - 1)) * 100}%`}
            stopColor={color}
          />
        ))}
      </linearGradient>
    </defs>
  );
};

export default GradientDefs;
